export const glossary = {
    title: '用語集',
    overview: 'Intelligent Business Analyticsのサービス内に登場する用語や分析に関連する用語を解説しています。'
}
